import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';

import { PeticaoTese } from '@app/models/peticao-tese.model';
import { PeticaoTeseService } from '@app/services/peticao-tese.service';


@Component({
  selector: 'app-peticao-tese-form',
  templateUrl: './peticao-tese-form.component.html'
})
export class PeticaoTeseFormComponent implements OnInit {

  aguardandoSolicitacao = false;
  titulo: string;
  lstErros: string[];
  cdsMask = new CDSMask();

  peticaoTese: PeticaoTese = new PeticaoTese();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private peticaoTeseService: PeticaoTeseService) { }

  ngOnInit() {

    const id = this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Modelo de Tese' : 'Novo Modelo de Tese';

      // novo
      if (!id) {
        this.peticaoTese.Ativo = true;
      } else {
        // editar
        this.peticaoTeseService.obterPorId(id).toPromise().then(
          data => this.peticaoTese = data,
          () => this.router.navigate(['./peticao/teses'])
        );
      }
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao=true;
    this.peticaoTeseService.gravar(this.peticaoTese)
      .toPromise().then(
        () => this.router.navigate(['./peticao/teses']),
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          }
          this.aguardandoSolicitacao = false;
        });
  }
}
